import { NzTreeNode } from "ng-zorro-antd";

export class FctreeBusiness {

    /**
     * è·åå½åéä¸­çkeyï¼ä¿æ¤åéä¸­ç¶æä¸ä¸çº§
     * @param pthis 
     * @param context 
     */
    static getSelectedKey(pthis, nodes: NzTreeNode[]): string {
        let keys = "";
        if (!nodes) {
            return keys;
        }
        nodes.forEach(node => {
            keys += node.key + ",";
            let temp = this.getChildrenKeys(node.getChildren());
            if (temp)
                keys += temp;
            // temp = this.getParentNodeKeys(node.getParentNode());
            // if (temp)
            //     keys += temp;
        })
        if (keys.substr(keys.length - 1, keys.length) === ',') {
            keys = keys.substr(0, keys.length - 1);
        }
        return keys;
    }
    /**
     * è·åå­éèç¹çå¼
     * @param node ç¶çº§èç¹
     */
    static getChildrenKeys(nodes: NzTreeNode[]): string {
        let key = "";
        if (nodes && nodes.length === 0) {
            return null;
        }
        nodes.forEach(node => {
            if (node.isHalfChecked || node.isChecked) {
                key += node.key + ",";
                if (node.getChildren() !== null) {
                    let temp = this.getChildrenKeys(node.getChildren());
                    if (temp) {
                        key += "," + temp;
                    }
                }
            }
        })
        return key;
    }
    /**
     * è·åç¶çº§èç¹çå¼
     * @param node ç¶çº§èç¹
     */
    static getParentNodeKeys(nodes: NzTreeNode[]): string {
        let key = "";
        if (!nodes) {
            return null;
        }
        nodes.forEach(node => {
            key += node.key + ",";
            if (node.getParentNode() !== null) {
                let temp = this.getParentNodeKeys([node.getParentNode()]);
                if (temp) {
                    key += temp + ",";
                }
            }
        })
        return key;
    }
    /**
     * ææ ç»æçæ°æ®è½¬åææ å½¢ç»ä»¶è¯å«çæ°æ®
     * @param list 
     * @param keyCode 
     * @param titleCode 
     * @param childCode 
     */
    static listChildToTreeNodes(list: any[], keyCode: string, titleCode: string, childCode: string): any[] {
        if (!list) {
            return null;
        }
        let nodes: any[] = [];
        list.forEach(item => {
            let node: any = {
                id: item.ID,
                expanded: false,
                key: item[keyCode],
                title: item[titleCode],
                isLeaf: true,
                DATA: item
            };
            if (item[childCode]) {
                let children = this.listChildToTreeNodes(item[childCode], keyCode, titleCode, childCode);
                node.isLeaf = false;
                node.expanded = true;
                node.children = children;
            }
            nodes.push(Object.assign({}, node));
        })
        return nodes;
    }

}